import { defineComponent } from 'vue';
import { PropValidator } from '../lib/types.js';
import useDefaultPropsFromContext from '../lib/useDefaultPropsFromContext.js';

const component = defineComponent({
  props: PropValidator,
  setup(props) {
    return {
      ...useDefaultPropsFromContext(props)
    };
  }
});

export { component as default };
